var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AgeVerificationCompleteBase',{attrs:{"iconSrc":"/img/age_verification/exclamation_circle.svg","iconAlt":_vm.$t('age_verification__complete__failure_title'),"titleKey":"age_verification__complete__failure_title"}})
}
var staticRenderFns = []

export { render, staticRenderFns }